import React, { useEffect } from 'react';
import { Platform } from 'react-native';
import { Stack, useRouter } from 'expo-router';
import { StatusBar } from 'expo-status-bar';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { checkIn } from '../src/data';
import { registerPush } from '../src/push';
import { hasSeenWelcome } from '../src/welcome';
import { D } from '../src/theme';

/**
 * 웹에서만: PC 브라우저로 열었을 때 폰 폭으로 가운데 모은다.
 *
 * 앱 화면은 폰 폭에 맞춰 짜여 있어서, 1920px 로 그대로 늘리면 딜 타일 두 개가 화면을 꽉 채워
 * 망가져 보인다. 제휴 심사(쿠팡·링크프라이스)는 등록한 사이트를 PC 로 열어 보므로 그게 곧 인상이 된다.
 *
 * `app/+html.tsx` 는 web output 이 "single" 이라 빌드에 안 들어간다. 그래서 여기서 넣는다.
 */
const WEB_CSS = 'html,body{background:#9B9B99}'
  + '#root{width:100%;max-width:520px;margin:0 auto;background:#C8C8C6}'
  + '@media(max-width:520px){#root{max-width:none}}';

export default function RootLayout() {
  const router = useRouter();
  useEffect(() => {
    if (Platform.OS !== 'web' || typeof document === 'undefined') return;
    if (document.getElementById('dh-web')) return;
    const el = document.createElement('style');
    el.id = 'dh-web';
    el.textContent = WEB_CSS;
    document.head.appendChild(el);
  }, []);
  useEffect(() => {
    registerPush((dealId) => router.push(`/deal/${dealId}`));
    checkIn().catch(() => {}); // 가입한 사람이면 오늘 출석 크레딧이 쌓인다
    // 처음 온 사람에게는 이 앱이 뭘 하는지부터 보여 준다. 두 번째부터는 바로 피드로 간다
    hasSeenWelcome().then((seen) => {
      if (!seen) router.replace('/welcome');
    });
  }, [router]);
  return (
    <SafeAreaProvider>
      <StatusBar style="dark" />
      <Stack screenOptions={{ headerShown: false, contentStyle: { backgroundColor: D.ground } }}>
        <Stack.Screen name="(tabs)" />
        <Stack.Screen name="welcome" options={{ gestureEnabled: false }} />
        <Stack.Screen name="deal/[id]" />
        {/* 조건 상세는 손으로 만든 뒤로가기 대신 네이티브 헤더를 쓴다.
            표준 뒤로가기 버튼과 안드로이드 하드웨어 뒤로가기, iOS 스와이프가 같이 붙는다. */}
        <Stack.Screen
          name="condition/[id]"
          options={{
            headerShown: true,
            title: '조건 수정',
            headerBackTitle: '뒤로',
            headerTintColor: D.ink,
            headerTitleStyle: { fontSize: 16, fontWeight: '800', color: D.ink },
            headerStyle: { backgroundColor: D.ground },
            headerShadowVisible: false,
          }}
        />
      </Stack>
    </SafeAreaProvider>
  );
}
